import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useNetworkStore } from "@/stores/network-store";

export const useMyNetworkPublicationApplicationsFeedStore = defineSmartFeedPiniaStore(
  "my-network-publication-applications-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        networkId: {
          key: "network_id",
          payload: useNetworkStore().networkId,
        },
      },
      tableFields: [
        { key: "publicationName", label: "Publication" },
        { key: "status", label: "Status" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/network/${useNetworkStore().networkId}/my-publication-applications`;
      },
    },
  },
);
